// src/components/modules/entertainment.js

import React, { useState } from 'react';
import {   BrowserView,
  MobileView,
  isBrowser,
  isMobile } from 'react-device-detect';




const Entertainment = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVisibility = () => {
    setIsExpanded(!isExpanded);
  };

  const isAppInstalled = (appName) => {
    const userAgent = navigator.userAgent;
    
    // Check if the device is mobile and the user agent string contains the app name
    if (isMobile && userAgent.includes(appName)) {
      return true; // App is installed
    }
    
    return false; // App is not installed
  };

  const isNetflixAppInstalled = () => {
    const userAgent = navigator.userAgent;
    return isMobile && userAgent.includes('Netflix');
  };

  const handleNetflixClick = (event) => {
    event.preventDefault();
    
    if (isNetflixAppInstalled()) {
      window.location.href = 'nflx://'; // Replace with the actual URL scheme or deep link
    } else {
      // Open the Netflix website
      window.open('https://www.netflix.com', '_blank');
    }
  };
  
  return (
    <div class={isExpanded ? 'container-expanded' : 'container'}>
      <button className={isExpanded ? 'expand-btn expanded' : 'expand-btn'} onClick={toggleVisibility}>
        {isExpanded ? 'Entertainment' : 'Entertainment'}
      </button>
      {isExpanded && (
        <ul>
          <li><a translate="no" href={isAppInstalled("YouTube") ? "youtube://" : "https://www.youtube.com"} target="_blank" rel="noopener noreferrer">YouTube</a></li>
          <li><a href="#" onClick={handleNetflixClick}>Open Netflix Experimental</a></li>
          <li><a translate="no" href="https://www.netflix.com" target="_blank" rel="noopener noreferrer">Netflix Browser</a> <a translate="no" href="nflx://" rel="noopener noreferrer">Netflix Android</a></li>
          <li><a translate="no" href="https://open.spotify.com" target="_blank" rel="noopener noreferrer">Spotify</a></li>
          <li><a translate="no" href={isAppInstalled("IMDB") ? "imdb://" : "https://www.imdb.com"} target="_blank" rel="noopener noreferrer">IMDB</a></li>
          <li><a translate="no" href="https://www.ign.com" target="_blank" rel="noopener noreferrer">IGN</a></li>
          <li><a translate="no" href="https://www.vulture.com" target="_blank" rel="noopener noreferrer">Vulture</a></li>
          <li><a translate="no" href={isAppInstalled("Reddit") ? "reddit://" : "https://www.reddit.com"} target="_blank" rel="noopener noreferrer">Reddit</a></li>
        </ul>
      )}
    </div>
  );
}

export default Entertainment;